import axios from '@/lib/axios';
import { PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0940. 発注案件契約タスクコメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};
const createPurchaseOrderContractTaskComment = (props: Props): Promise<PurchaseOrderContractTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_comments`,
    props
  );
};

export const useCreatePurchaseOrderContractTaskComment = () => {
  return useMutation({
    mutationFn: createPurchaseOrderContractTaskComment,
  });
};
